import { Select } from '@zoopla-eng/zds-components/select';
import {
    filterWrapperStyle,
    radiusDropdownWrapperStyle
} from './SearchInitiationMobileModal.styles.css';

const radii = [
    '',
    '0',
    '0.25',
    '0.5',
    '1',
    '3',
    '5',
    '10',
    '15',
    '20',
    '30',
    '40'
];

const radiiOptions = [
    { value: '0', text: 'This area only' },
    { value: '0.25', text: '+ 0.25 miles' },
    { value: '0.5', text: '+ 0.5 miles' },
    { value: '1', text: '+ 1 miles' },
    { value: '3', text: '+ 3 miles' },
    { value: '5', text: '+ 5 miles' },
    { value: '10', text: '+ 10 miles' },
    { value: '15', text: '+ 15 miles' },
    { value: '20', text: '+ 20 miles' },
    { value: '30', text: '+ 30 miles' },
    { value: '40', text: '+ 40 miles' }
];

export type Radius = (typeof radii)[number];

type SelectRadiusProps = {
    value: Radius;
    onChange: (radius: Radius) => void;
};

export const SelectRadius = ({ value, onChange }: SelectRadiusProps) => {
    const radiusLabel = 'Radius';

    const options = radiiOptions.map((radiiOption, index) => ({
        id: radiiOption.value,
        text: radiiOption.text
    }));

    return (
        <div className={filterWrapperStyle}>
            <div className={radiusDropdownWrapperStyle}>
                <Select
                    options={options}
                    onSelectedOptionChange={(o) => {
                        onChange(o.id);
                    }}
                    selectedOption={
                        options.find((o) => o.id === value) ?? options[0]
                    }
                    label={radiusLabel}
                />
            </div>
        </div>
    );
};
